import { Grid, List, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { BentoContact } from "schemas/dashboard";

import ContactListItem from "features/Influencer/QuickSendIndividualDrawer/PreviewPerContact/PreviewIndividual/ContactListItem";
import {
  accessToPartnershipData,
  contactAskForRates,
  contactDiscussedCollab,
  contactReplied,
  contactShowedInterest,
} from "utils/influencer";

function ContactInsights({
  bentoContact,
  title = "Contact Insights",
}: {
  bentoContact: BentoContact;
  title: string;
}) {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription, isVaPlan } = useContext(SubscriptionContext);

  const hasAccessToPartnershipData = accessToPartnershipData(
    currentOrg,
    subscription,
    isVaPlan,
  );

  if (!hasAccessToPartnershipData) {
    return <></>;
  }

  if (!contactReplied(bentoContact) && !bentoContact.lastSentToAt) {
    return <></>;
  }

  return (
    <Grid item xs={12} md>
      <Typography gutterBottom>
        <strong>{title}</strong>
      </Typography>
      <List dense disablePadding sx={{ mb: 1 }}>
        <ContactListItem isActive text="Email verified (not bounced)" />
        <ContactListItem
          isActive={contactReplied(bentoContact)}
          text="Replied to a user on platform"
        />
        {contactAskForRates(bentoContact) ? (
          <ContactListItem isActive text="Asked a user for rates" />
        ) : contactDiscussedCollab(bentoContact) ? (
          <ContactListItem
            isActive
            text="Discussed a specific opportunity with a user"
          />
        ) : contactShowedInterest(bentoContact) ? (
          <ContactListItem
            isActive
            text="Showed general interest in working with creators"
          />
        ) : (
          <></>
        )}
      </List>
    </Grid>
  );
}

export default ContactInsights;
